"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizonEnrollmentProgress = 'HorizonEnrollmentProgress';
var HorizonEnrollmentState;
(function (HorizonEnrollmentState) {
    HorizonEnrollmentState["PriceShared"] = "PriceShared";
    HorizonEnrollmentState["LinkReceived"] = "LinkReceived";
    HorizonEnrollmentState["LinkSent"] = "LinkSent";
    HorizonEnrollmentState["LinkOpened"] = "LinkOpened";
    HorizonEnrollmentState["Enrolled"] = "Enrolled";
    HorizonEnrollmentState["Failed"] = "Failed";
})(HorizonEnrollmentState = exports.HorizonEnrollmentState || (exports.HorizonEnrollmentState = {}));
var AmEnrollmentState;
(function (AmEnrollmentState) {
    AmEnrollmentState["Pending"] = "Pending";
    AmEnrollmentState["Enrolled"] = "Enrolled";
    AmEnrollmentState["Failed"] = "Failed";
})(AmEnrollmentState = exports.AmEnrollmentState || (exports.AmEnrollmentState = {}));
exports.AmEnrollmentProgress = 'AmEnrollmentProgress';
exports.AMEnrollmentFailureAfterRetrySubType = 'AMEnrollmentFailedAfterRetry';
exports.EnrollmentPendingTimeoutSubType = 'EnrollmentPendingTimeout';
exports.VerizonEnrollmentPublished = 'VerizonEnrollmentPublished';
exports.HorizonEnrollmentPublished = 'HorizonEnrollmentPublished';
